import React, { useEffect, useState } from "react";
import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";

import "./nujobsMyResumes.scss";
import cloudIcon from "../../../assets/upload.png";
import NuJobsResumeAddModal from "../nujobsResumeAddModal";
import useNuJobsResumeAddModalStore from "../../../store/nujobsResuneAddModal.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import NuJobsCandidateProfilePreview from "../nujobsCandidateProfilePreview";
import NuJobsTable from "../nujobsTable";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";

export default function NUJobsMyResumes() {
  const navigate = useNavigate();

  const { nujobsGetMyResumes, myResumes } = useNuJobDetailsStore();
  const { setCandidateModalOpen } = useNuJobsResumeAddModalStore();

  const nujUserDetails = JSON.parse(localStorage.getItem("nujobsUserDetails"));
  const [selectedResume, setSelectedResume] = useState(null);
  const checkMultipleResumeAllowed = () =>{
    console.log("user data",myResumes)
    if(nujUserDetails.trialstatus == "trial_none" && nujUserDetails.subscriptionstatus == "subscription_none"){
      if(myResumes?.length <1){
         return true
      }else if (myResumes?.length ==1){
          if(myResumes?.[0].resumestatus == "NO_RES"){
             return true
          }
          return false
      }else {
         return false
      }
    }else{
      return true
    }
  }
  
  const [showResumeUpload, setShowResumeUpload] = useState(true);
  useEffect(() => {
    nujobsGetMyResumes();
  }, []);


  function formatUnixDate(ts) {
    const d = new Date(ts * 1000);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }


  const resumeData =
    myResumes?.map((resume, idx) => ({
      id: idx + 1,
      resumeName: resume?.resumename,
      skills:resume?.myresume?.skilltags,
      email: resume?.myresume?.personaldetail?.email,
      contact: resume?.myresume?.personaldetail?.mobile,
      AddedOn: formatUnixDate(resume?.myresume?.timestamp),
      Status: resume?.resumestatus,
      isDefault:resume?.isdefault,
    })) || [];

  useEffect(() => {
    if (resumeData.length > 0 && !selectedResume) {
      setSelectedResume(resumeData[0]);
    }
    var showResumeUpload = checkMultipleResumeAllowed()
    setShowResumeUpload(showResumeUpload)
  }, [resumeData]);

  const titleList = [
    "Select",
    "SN",   
    "Resume Name",
    "Skills",    
    "Email",
    "Contact",
    "Uploading Date",
    "Resume Status",
    "Default Resume",
  ];  
  const resumeProfileHandler =(id) =>{
     navigate(`/nujobshome/nujobsCandidateProfilePreview/${id}`);
  }

  return (
    <div className="nujobscandidate-resume-container">
        {/* HEADER */}
      <div className="nujobs-resume-container">
        <div className="jobs-header">
          <div className="header-left">My Resumes</div>
          {
            showResumeUpload?
            <>
                <div className="img">
                  <Button
                      onClick={setCandidateModalOpen}
                      className="btn"
                      type="primary"
                  >
                      <img
                        src={cloudIcon}
                        alt="Upload"
                        margin="10px"
                        width="30" height="30"
                        className="image"
                      />
                      Upload Resume
                  </Button>   
                </div>
            </>
            :<>
            </>
          }

        </div>
    
        {resumeData?.filter((item) => item.Status != "NO_RES")?.length > 0 ? (
          <NuJobsTable
            onClickCallBack = {resumeProfileHandler}
            isClickable={true}
            titleList={titleList}
            data={resumeData?.filter((item) => item.Status != "NO_RES")}
            columnWidth={[50, 50, 100, 200, 200, 200, 100, 100, 100]}
            resumePage={true}
        />
      ) : (
        <Empty style={{ margin: "60px" }}>
          Kindly Upload Resume(s). Max 1 Resumes can be uploaded.
        </Empty>
      )}
      </div>
      <div className="nujobs-footer">
        <NuJobsSignedInFooter />
      </div>

        <NuJobsResumeAddModal/>   
    </div>
  );
}